"use strict";

/**
 * Plain old identity function
 */

module.exports = function (x) {
  return x;
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/ordinal-js/dist/identity.js
// module id = 3274
// module chunks = 0